import * as R from 'ramda'
import DOMPurify from "dompurify";



export const cleanupFormValue = formValue => {
  const cleanValue = value => {
    if (typeof value === 'boolean') {
      return value;
    }
    if (R.is(Array, value)) {
      return R.map(innerValue => {
        if (R.is(Object, innerValue) && !R.is(Array, innerValue)) {
          return cleanupFormValue(innerValue);
        }
        return DOMPurify.sanitize(innerValue, {ALLOWED_TAGS: []});
      }, value);
    }
    
    if (R.is(Object, value) && !R.is(Array, value)) {
      return cleanupFormValue(value);
    }
    
    return DOMPurify.sanitize(value, {ALLOWED_TAGS: []});
  };  

  return R.map(partFormValue => {
    if (R.is(Object, partFormValue) && !R.is(Array, partFormValue)) {
      return R.map(cleanValue, partFormValue);
    }
    return cleanValue(partFormValue);
  }, formValue);
}